module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("Blog Details"), _c('small', [_c('i', {
    staticClass: "ti-heart"
  }), _c('i', {
    staticClass: "ti-export"
  }), _c('i', {
    staticClass: "ti-printer"
  })])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Apps")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Blog Detail Page")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box",
    staticStyle: {
      "padding": "30px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "blog-list-nest"
  }, [_c('div', {
    staticClass: "vendor"
  }, [_c('img', {
    staticClass: "img-responsive-media",
    attrs: {
      "src": "https://source.unsplash.com/collection/190727/1600x900",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "blog-list-content"
  }, [_c('h2', [_vm._v("Favright")]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline blog-devin-tag"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-pencil"
  }), _vm._v(" 2 Days Ago")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-comment-alt"
  }), _vm._v(" 2 Comments")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "ti-rss-alt"
  }), _vm._v(" 14 Shares")])])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam condimentum sollicitudin mi, vitae vehicula justo venenatis at. Morbi tempor fermentum velit non pretium. Phasellus at lacus turpis. Curabitur dapibus pulvinar velit eu rutrum. Nulla adipiscing sapien orci, ac iaculis justo euismod vitae. Fusce tincidunt accumsan erat, a molestie eros auctor a. Suspendisse vel nibh vulputate, porttitor neque in, pellentesque lectus. Pellentesque aliquet diam sed placerat scelerisque. Suspendisse eleifend sem urna, eget viverra nunc interdum quis. Nam porta nunc turpis. Pellentesque ut adipiscing mi, eu facilisis turpis.")]), _vm._v(" "), _c('p', [_vm._v("Nunc ac erat semper, ultrices lorem eu, pretium urna. Etiam nibh nibh, laoreet id pharetra sit amet, interdum at sapien. Fusce venenatis velit in diam auctor tempus. Duis feugiat consectetur urna vel suscipit. In in lorem placerat, tempus velit ac, aliquam diam. Cras vestibulum velit posuere, elementum enim sed, imperdiet nisl. Etiam scelerisque purus tempus, fringilla dolor at, sodales nibh. Morbi molestie porta nunc, ut tincidunt ante euismod vitae. Mauris vehicula augue augue, ut placerat sapien porta vel. Curabitur laoreet odio et nibh hendrerit consequat. Quisque aliquet orci est, condimentum dignissim felis tempus eget. Morbi ac bibendum velit, eget aliquam nisi. Integer posuere consequat purus non mollis. Integer posuere vitae massa a posuere. Vivamus at lectus at elit aliquam pulvinar porta nec turpis.")]), _vm._v(" "), _c('p', [_vm._v("Vestibulum eu scelerisque ante, eget molestie tellus. Aenean eget sagittis massa. Fusce et ligula ultricies, venenatis leo et, posuere orci. Aenean euismod augue id orci consequat, eget lobortis ante blandit. Nulla tempus viverra mattis. Maecenas volutpat ut massa pellentesque tristique. Morbi erat enim, dapibus ornare laoreet non, auctor sit amet lorem. Integer nec lorem a risus tristique viverra. Quisque aliquam nisl eu ante pretium, vel volutpat leo tempus. Nam velit arcu, tincidunt eget viverra vitae, auctor ac neque.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "pull-left"
  }, [_c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Typhography")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "comment-nest"
  }, [_c('h1', [_vm._v("Leave a Comment:")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "Please input"
    },
    model: {
      value: (_vm.textarea),
      callback: function($$v) {
        _vm.textarea = $$v
      },
      expression: "textarea"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', [_vm._v("Submit")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', {
    staticClass: "media-list"
  }, [_c('li', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-circle",
    staticStyle: {
      "width": "64px",
      "height": "64px"
    },
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/thumb/women/21.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('div', {
    staticClass: "social-profile"
  }, [_c('h3', [_c('a', {
    staticClass: "link-comment",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Destya Susilowati")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "entypo-globe"
  }), _vm._v(" 1 hours ago")]), _vm._v(" "), _c('span', [_c('a', {
    staticClass: "link-comment",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fontawesome-share"
  }), _vm._v(" Reply")])])])]), _vm._v(" "), _c('p', [_vm._v("Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-circle",
    staticStyle: {
      "width": "64px",
      "height": "64px"
    },
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/thumb/men/40.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('div', {
    staticClass: "social-profile"
  }, [_c('h3', [_c('a', {
    staticClass: "link-comment",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Awangizm")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "entypo-globe"
  }), _vm._v(" 1 hours ago")]), _vm._v(" "), _c('span', [_c('a', {
    staticClass: "link-comment",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fontawesome-share"
  }), _vm._v(" Reply")])])])]), _vm._v(" "), _c('p', [_vm._v("Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-circle",
    staticStyle: {
      "width": "64px",
      "height": "64px"
    },
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/thumb/women/21.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('div', {
    staticClass: "social-profile"
  }, [_c('h3', [_c('a', {
    staticClass: "link-comment",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Symponia")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "entypo-globe"
  }), _vm._v(" 1 hours ago")]), _vm._v(" "), _c('span', [_c('a', {
    staticClass: "link-comment",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fontawesome-share"
  }), _vm._v(" Reply")])])])]), _vm._v(" "), _c('p', [_vm._v("Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.")])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-circle",
    staticStyle: {
      "width": "64px",
      "height": "64px"
    },
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/thumb/men/55.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('div', {
    staticClass: "social-profile"
  }, [_c('h3', [_c('a', {
    staticClass: "link-comment",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Agus Berontazk")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "entypo-globe"
  }), _vm._v(" 12 minute ago")]), _vm._v(" "), _c('span', [_c('a', {
    staticClass: "link-comment",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fontawesome-share"
  }), _vm._v(" Reply")])])])]), _vm._v(" "), _c('p', [_vm._v("Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin commodo. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.")])])])])])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "pager success"
  }, [_c('li', {
    staticClass: "previous"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("← Older")])]), _vm._v(" "), _c('li', {
    staticClass: "next disabled"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Newer →")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('img', {
    staticClass: "media-object img-circle blog-profile",
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/thumb/men/10.jpg"
    }
  }), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    staticClass: "lead text-center"
  }, [_vm._v("Dave Mattew")]), _vm._v(" "), _c('p', {
    staticClass: "tex-center social-blog-profile"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "entypo-facebook-circled"
  })]), _vm._v(" "), _c('a', {
    staticClass: "tweet-link",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "entypo-twitter-circled"
  })]), _vm._v(" "), _c('a', {
    staticClass: "gplus-textcolor",
    attrs: {
      "href": "#"
    }
  }, [_c('span', {
    staticClass: "entypo-instagrem"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "social-follower text-center"
  }, [_vm._v("A graphics designer, a web developer, a boyfriend, a friend, a son")])])]), _vm._v(" "), _c('div', {
    staticClass: "blog-side-nest"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("JOIN NEWSLETTER")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Sign up for our daily Newslatter")]), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Enter email"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-full-width-left"
  }, [_c('button', {
    staticClass: "btn btn-info btn-block",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Sign up")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "blog-side-nest"
  }, [_c('h4', {
    staticClass: "text-left"
  }, [_vm._v("POPULAR POST")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-responsive-media",
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/men/17.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "media-heading"
  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
    staticClass: "link-comment recentpost-link",
    staticStyle: {
      "margin": "-10px 0 10px"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("88 Views")])])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-responsive-media",
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/men/21.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "media-heading"
  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
    staticClass: "link-comment recentpost-link",
    staticStyle: {
      "margin": "-10px 0 10px"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("90 Views")])])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-responsive-media",
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/men/20.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "media-heading"
  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
    staticClass: "link-comment recentpost-link",
    staticStyle: {
      "margin": "-10px 0 10px"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("42 Views")])])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-responsive-media",
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/men/19.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "media-heading"
  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
    staticClass: "link-comment recentpost-link",
    staticStyle: {
      "margin": "-10px 0 10px"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("111 Views")])])]), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "pull-left",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "media-object img-responsive-media",
    attrs: {
      "data-src": "holder.js/64x64",
      "alt": "64x64",
      "src": "http://api.randomuser.me/portraits/men/18.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('h5', {
    staticClass: "media-heading"
  }, [_vm._v("Cras sit amet nibh Lorem ipsum dolor si amet")]), _vm._v(" "), _c('a', {
    staticClass: "link-comment recentpost-link",
    staticStyle: {
      "margin": "-10px 0 10px"
    },
    attrs: {
      "href": "#"
    }
  }, [_vm._v("123 Views")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "blog-side-nest"
  }, [_c('h4', {
    staticClass: "text-left"
  }, [_vm._v("TAG")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin": "0"
    }
  }), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Fleet")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Music")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Video")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Typhography")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Computer")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Web Design")]), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "gray"
    }
  }, [_vm._v("Movie")])], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a5bf610!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/BlogDetails.vue
// module id = 985
// module chunks = 2